<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" @click="showModal()"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-3"></div>
        <b-row class="mb-2">
            <!--<b-col md="4">
                <b-form-select v-model="tableFilter.qrcodeType" :options="qrcodeList" />
            </b-col>-->
            <b-col md="4 mb-2">
                <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
            </b-col>
            <b-col md="4 mb-2">
                <b-form-select v-model="tableFilter.status" :options="statusList" />
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-delete="false" :can-show="false" :can-view="true" :can-download="false" :can-edit-modal="false" :can-edit="false" :can-reject="false" :can-approve="false" :can-print="true" :data-url="apiUrl.qrcode" :data-key="dataKey" :data-columns="columns" :data-params="['available', 'start_date', 'end_date', 'type']">
        </paginated-table>
        <b-modal ref="my-modal" centered hide-footer title="Generate QR Code">
            <form v-on:submit.prevent="doSubmit">
                <label for="" class="mt-1">Units <label style="font-size:10px!important;">(in number)</label> *</label>
                <b-form-input type="number" class="mb-3" placeholder="Enter Units" v-model="model.units" name="units" v-bind:class="errors.has('units') ? 'is-invalid':''" v-validate="'required'"></b-form-input>
                <!--<label for="" class="mt-1">Type *</label>
                <b-form-select class="mb-2" v-model="model.type" :options="typeList" />-->
                <b-button class="mt-3" variant="secondary" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
                <b-button class="mt-3 float-right" variant="primary" type="submit"><font-awesome-icon icon="save"></font-awesome-icon>{{this.model.uuid !== null ? ' Update' : ' Submit'}} </b-button>
            </form>
        </b-modal>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    export default {
        name: 'qr-code',
        components: {
            PaginatedTable,
            DatePicker
        },
        data () {
            return {
                dataKey: 'qrCode',
                apiUrl: {
                    qrcode: window.AppConfig.apiUrl + 'qrcode',
                    generate: window.AppConfig.apiUrl + 'generate-qr-code'
                },
                type: null,
                model: {
                    uuid: null,
                    name: null,
                    units: null,
                    type: 'Customer'
                },
                typeList: [
                    {
                        value: 'Customer',
                        text: 'Customer'
                    },
                    {
                        value: 'Customer Asset',
                        text: 'Customer Asset'
                    },
                    {
                        value: 'Items',
                        text: 'Items'
                    }
                ],
                columns: [
                    {
                        key: 'value',
                        label: 'QR Code Value',
                        sortable: true
                    },
                    // {
                    //     key: 'type',
                    //     label: 'Type',
                    //     sortable: true
                    // },
                    {
                        key: 'createdAt',
                        label: 'Created',
                        sortable: true
                    },
                    {
                        key: 'isAvailable',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'actionsQrcode',
                        label: ''
                    }
                ],
                qrcodeList: [
                    {
                        value: null,
                        text: 'All Type'
                    },
                    {
                        value: 'Customer',
                        text: 'Customer'
                    },
                    {
                        value: 'Customer Asset',
                        text: 'Customer Asset'
                    },
                    {
                        value: 'Items',
                        text: 'Items'
                    },
                ],
                statusList: [
                    {
                        value: null,
                        text: 'Status'
                    },
                    {
                        value: 1,
                        text: 'Available'
                    },
                    {
                        value: 0,
                        text: 'Not Available'
                    }
                ],
                tableFilter: {
                    type: this.$route.query.type,
                    qrcodeType: null,
                    available: this.$route.query.available,
                    status: null,
                    date: null,
                    start_date: this.$route.query.start_date,
                    end_date: this.$route.query.end_date
                }
            }
        },
        watch: {
            'tableFilter.qrcodeType' () {
                this.doFilter()
            },
            'tableFilter.status' () {
                this.doFilter()
            },
            'tableFilter.date' (value) {
                if (value !== null && value.length >= 1 && value[0] === null && value[1] === null) {
                    this.tableFilter.date = null
                    this.doFilter()
                } else {
                    this.doFilter()
                }
            }
        },
        methods: {
            doFilter() {
                this.tableFilter.available = this.tableFilter.status
                this.tableFilter.type = this.tableFilter.qrcodeType
                this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
                this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            showModal() {
                this.model.units = null
                this.model.type = this.model.type
                this.model.uuid = null
                this.$validator.reset();
                this.$refs['my-modal'].show()
            },
            hideModal() {
                this.$refs['my-modal'].hide()
            },
            // showEditModal (row) {
            //     this.type = row.type
            //     this.model.name = row.name
            //     this.model.uuid = row.uuid
            //     this.$refs['my-modal'].show()
            // },
            doSubmit () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        this.$http.post(this.apiUrl.generate, {
                            units: this.model.units,
                            type: this.model.type
                        }).then(response => {
                            this.$store.dispatch('notification/success', 'QR Code has been added.')
                            this.$refs.dataTable.doFilter()
                            this.hideModal()
                        }).catch(error => {
                            this.$store.dispatch('notification/error', error)
                        })
                        // if (this.model.uuid !== null) {
                        //     this.$http.patch(this.apiUrl + '/' + this.model.uuid, {
                        //         name: this.model.name
                        //     }).then(response => {
                        //         this.$store.dispatch('notification/success', 'QR Code has been updated.')
                        //         this.$refs.dataTable.doFilter()
                        //         this.hideModal()
                        //     }).catch(error => {
                        //         this.$store.dispatch('notification/error', error)
                        //     })
                        // } else {
                        // }
                    }
                })
            }
        }
    }
</script>